import React, { FC } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'

interface IProps {
  show: boolean
  onConfirm: () => void
  onCancel: () => void
  newSpecialPrice: string
}

const NewSpecialPriceModal: FC<IProps> = ({
  show,
  onConfirm,
  onCancel,
  newSpecialPrice,
}) => {
  const { formatMessage } = useIntl()

  return (
    <Modal show={show} onHide={onCancel} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>{formatMessage({ id: 'new_special_price_title' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>{formatMessage(
            { id: 'new_special_price_message' },
            { newSpecialPrice: newSpecialPrice }
          )}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {formatMessage({ id: 'cancel' })}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {formatMessage({ id: 'ok' })}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default NewSpecialPriceModal
